module.exports = __webpack_public_path__ + "img/main-cover.3543edb9.png";